import { useState } from 'react';
import { Mail, MessageCircle, Send } from 'lucide-react';
import { SEOHead } from '@/components/seo';
import { PAGE_SEO } from '@/lib/seo-config';

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => { e.preventDefault(); setSent(true); };

  return (
    <div className="bg-[#050505] min-h-screen pt-24">
      <SEOHead
        title={PAGE_SEO.contact.title}
        description={PAGE_SEO.contact.description}
        keywords={PAGE_SEO.contact.keywords}
        url="/contact"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Contact', url: '/contact' },
        ]}
      />
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 data-testid="contact-title" className="text-4xl sm:text-5xl font-bold text-white mb-4 section-marker">Contact Us</h1>
          <p className="text-zinc-400 mb-12">Have a question? We'd love to hear from you.</p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="md:col-span-2">
              {sent ? (
                <div data-testid="contact-success" className="bg-emerald-500/5 border border-emerald-500/20 rounded-sm p-12 text-center">
                  <Send size={40} className="text-emerald-400 mx-auto mb-4" />
                  <p className="text-white font-mono text-lg mb-2">Message Sent</p>
                  <p className="text-zinc-500 text-sm">We'll get back to you within 24 hours.</p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div><label className="block text-xs font-mono text-zinc-500 mb-1.5">Name</label><input data-testid="contact-name" required value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full bg-[#0A0A0A] border border-zinc-800 text-white rounded-sm px-4 py-2.5 text-sm font-mono focus:border-emerald-500/50 outline-none placeholder-zinc-600" placeholder="Your name" /></div>
                    <div><label className="block text-xs font-mono text-zinc-500 mb-1.5">Email</label><input data-testid="contact-email" type="email" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="w-full bg-[#0A0A0A] border border-zinc-800 text-white rounded-sm px-4 py-2.5 text-sm font-mono focus:border-emerald-500/50 outline-none placeholder-zinc-600" placeholder="you@company.com" /></div>
                  </div>
                  <div><label className="block text-xs font-mono text-zinc-500 mb-1.5">Subject</label><input data-testid="contact-subject" required value={form.subject} onChange={e => setForm({...form, subject: e.target.value})} className="w-full bg-[#0A0A0A] border border-zinc-800 text-white rounded-sm px-4 py-2.5 text-sm font-mono focus:border-emerald-500/50 outline-none placeholder-zinc-600" placeholder="How can we help?" /></div>
                  <div><label className="block text-xs font-mono text-zinc-500 mb-1.5">Message</label><textarea data-testid="contact-message" required rows={6} value={form.message} onChange={e => setForm({...form, message: e.target.value})} className="w-full bg-[#0A0A0A] border border-zinc-800 text-white rounded-sm px-4 py-2.5 text-sm font-mono focus:border-emerald-500/50 outline-none placeholder-zinc-600 resize-none" placeholder="Tell us more..." /></div>
                  <button data-testid="contact-submit" type="submit" className="bg-emerald-500 text-black font-mono font-bold text-sm rounded-sm px-6 py-3 hover:bg-emerald-400 transition-all click-scale shadow-[0_0_15px_rgba(16,185,129,0.3)]">Send Message</button>
                </form>
              )}
            </div>
            <div className="space-y-4">
              <div className="bg-[#0A0A0A] border border-zinc-800 rounded-sm p-5">
                <Mail size={20} className="text-emerald-400 mb-3" />
                <h3 className="text-sm font-mono text-white font-bold mb-1">Email</h3>
                <p className="text-xs text-zinc-500">support@clawstinger.com</p>
              </div>
              <div className="bg-[#0A0A0A] border border-zinc-800 rounded-sm p-5">
                <MessageCircle size={20} className="text-cyan-400 mb-3" />
                <h3 className="text-sm font-mono text-white font-bold mb-1">Discord</h3>
                <p className="text-xs text-zinc-500">Join our community server</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
